import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=9bf51b1a"
var script = {}
import style0 from "./agreement.vue?vue&type=style&index=0&id=9bf51b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports